<template>
    <component :is="component" class="uik-top-bar-title__wrapper" @click="$emit('click')">
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: "UikTopBarTitle",
    props: {
        component: { type: String, default: "h2" }
    }
}
</script>

<style lang="scss">
.uik-top-bar-title__wrapper {
  font-weight: 500;
  font-size: 1rem;
  color: $textMain;
  line-height: 1.75;
  display: flex;
  align-items: center;
  white-space: nowrap;
  &.uik-top-bar-title__large {
    font-size: 1.125rem;
  }
  i {
    margin-right: 14px;
    color: $textSecondary;
  }
  @media only screen and (max-width: 500px) {
    font-size: 0.88rem;
    .uikon {
      margin-right: 10px;
    }
  }
  @media only screen and (max-width: 370px) {
    .uikon {
      display: none;
    }
  }
}
</style>
